import { FormHelperText } from "@mui/material";
import { forwardRef } from "react";

import { renderIf } from "@/common/helpers/render/renderIf";
import { AssetDto, AssetEntityType } from "@/core/api/generated/v1";

import AppIcon, { AppIconProps } from "../../Icons/AppIcon";

type AppIconPropsLocal = Omit<AppIconProps, "of">;

interface Props extends AppIconPropsLocal {
  entity: AssetDto | null | undefined;
}

export default forwardRef<SVGSVGElement, Props>(function AssetIcon(
  { entity, ...iconProps }: Props,
  ref,
) {
  if (!entity) {
    return null;
  }

  return (
    <>
      {renderIf()
        .if(entity.entityType === AssetEntityType.Vehicle)
        .then(<AppIcon ref={ref} of='vehicle' {...iconProps} />)
        .elseif(entity.entityType === AssetEntityType.Accessory)
        .then(<AppIcon ref={ref} of='accessory' {...iconProps} />)
        .else(<FormHelperText error>Unknown asset entity {entity.entityType}</FormHelperText>)
        .render()}
    </>
  );
});
